import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ROUTES } from '@/config/routes';

const BrandOverviewPage = lazy(() =>
  import('./routes/BrandOverviewPage').then((m) => ({ default: m.BrandOverviewPage })),
);

/**
 * The Brand Overview screen, at `/BrandOverview/:brandSlug`.
 *
 * <p>**Listed inside the `<ProductRoute />` group in `app/router`**, like the Brand Analyser
 * that links to it, so `brand_intelligence` is demanded by placement. Listed before
 * `placeholderRoutes`, whose entry for this path is gone now that this exists.
 */
export const brandOverviewRoutes: RouteObject[] = [
  { path: ROUTES.brandOverview, element: <BrandOverviewPage /> },
];
